import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { HeroSection } from './components/sections/HeroSection';
import { QuestionsSection } from './components/sections/QuestionsSection';
import { RoadmapSection } from './components/sections/RoadmapSection';
import { BeforeAfterSection } from './components/sections/BeforeAfterSection';
import { FamiliarSection } from './components/sections/FamiliarSection';
import { PiecesSection } from './components/sections/PiecesSection';
import { VolumesSection } from './components/sections/VolumesSection';
import { ResourcesSection } from './components/sections/ResourcesSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { OfferSection } from './components/sections/OfferSection';
import { GuaranteeSection } from './components/sections/GuaranteeSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { MessageSection } from './components/sections/MessageSection';
import { FaqSection } from './components/sections/FaqSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { SiteFooter } from './components/sections/SiteFooter';
import { FloatingCta } from './components/ui/FloatingCta';
import { PurchasePopup } from './components/ui/PurchasePopup';
export function App() {
  return <div className="w-full overflow-x-hidden bg-ink font-sans" data-id="element-0" data-mp="82kl3wchwbg">
      <MetaPixel data-id="element-1" data-mp="2zm4vedw4z0yn" />
      <HeroSection data-id="element-2" data-mp="2zmo89g6xiz5t" />
      <main data-id="element-3" data-mp="2zng14j956ise">
        <QuestionsSection data-id="element-4" data-mp="33mowttnqsqql" />
        <RoadmapSection data-id="element-5" data-mp="33lwzoeehyky7" />
        <BeforeAfterSection data-id="element-6" data-mp="33n6yx6x35z6f" />
        <FamiliarSection data-id="element-7" data-mp="33oi2p6qj76xj" />
        <PiecesSection data-id="element-8" data-mp="38l8idsyfc0if" />
        <VolumesSection data-id="element-9" data-mp="38kqau06b9zv7" />
        <ResourcesSection data-id="element-10" data-mp="38kgmsi4tu2s5" />
        <BonusesSection data-id="element-11" data-mp="3dkuu1xylt8p4" />
        <OfferSection data-id="element-12" data-mp="3dl4mrtb19tyi" />
        <GuaranteeSection data-id="element-13" data-mp="3dlns8ajhypvn" />
        <TestimonialsSection data-id="element-14" data-mp="3dirwmsv4gdad" />
        <MessageSection data-id="element-15" data-mp="nvstj3irmlvf" />
        <FaqSection data-id="element-16" data-mp="nuhh6fb985sp" />
        <FinalCtaSection data-id="element-17" data-mp="nv0wrpdfmi3k" />
      </main>
      <SiteFooter data-id="element-18" data-mp="sunbk38ws6eh" />
      <FloatingCta data-id="element-19" data-mp="su42zd55eud4" />
      <PurchasePopup data-id="element-20" data-mp="stkj3qvxtvwg" />
    </div>;
}